var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteHomeLocker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.627,
    height: 22.417,
    viewBox: "0 0 20.627 22.417",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#479ed5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(371.949 -4611.479)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-358.577,4623.75a.65.65,0,0,0-.65-.65h-5.5a.65.65,0,0,0-.65.65.65.65,0,0,0,.65.651h5.5A.65.65,0,0,0-358.577,4623.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-370.548,4616.359a1.354,1.354,0,0,1,1.351-1.353h4.257v-1.4H-369.2a2.756,2.756,0,0,0-2.752,2.753v4.257h1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-370.548,4631.143v-4.257h-1.4v4.257a2.756,2.756,0,0,0,2.752,2.753h4.257v-1.4H-369.2A1.353,1.353,0,0,1-370.548,4631.143Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-353.889,4631.143a1.353,1.353,0,0,1-1.351,1.352H-359.5v1.4h4.257a2.756,2.756,0,0,0,2.751-2.753v-4.257h-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-358.466,4620.595h1.53v-3.111h2.7v3.111h1.49v-4.834h1.42l-4.282-4.282-4.282,4.282h1.42Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteHomeLocker);
export default __webpack_public_path__ + "static/media/deleteHomeLocker.08279a3f2ea3d21a5cdcc7c7c84fe033.svg";
export { ForwardRef as ReactComponent };